import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusInProgressIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { stroke: 'none', viewBox: '0 0 28 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M10.5574 1.99999C12.097 -0.666672 15.946 -0.666666 17.4856 2L26.5788 17.75C28.1184 20.4167 26.1939 23.75 23.1147 23.75H4.9282C1.849 23.75 -0.0754991 20.4167 1.4641 17.75L10.5574 1.99999Z', fill: 'currentColor' }) })));
};
//# sourceMappingURL=status_in_progress.icon.js.map